import {Pipe, PipeTransform} from '@angular/core';
import { checkJsonObject, replaceCitations, sanitizeJson } from '@core/utils';

@Pipe({
    name: 'chatAnswer',
    standalone: false
})
export class ChatAnswer implements PipeTransform{
    transform(value: string): string {
        return sanitizeJson(value)?.answer ?? value;
    }
}
